module.exports = __webpack_public_path__ + "static/media/iphone_12_mini_blue.c1e63bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_mini_blue.png
// module id = 2083
// module chunks = 0